import {
  ModuleWithProviders, NgModule,
  Optional, SkipSelf }            from '@angular/core';
import { HttpClientModule }       from '@angular/common/http';

import { CommonModule }           from '@angular/common';

import { UserService }            from './services/user.service';
import { NetworkService }         from './services/network.service';
import { EventsService }          from './services/events.service';
import { ScreenSizeService }      from './services/screen-size.service';
import { LanguageService }        from './services/language.service';
import { WishListService }        from './services/wish-list.service';
import { AuthenticationService }  from './services/authentication.service';
import { CartService }            from './services/cart.service';
import { AppConfig }              from '../app.config';
import { ScreenSizeDirective }    from './directives/screen-size.directive';
import { ScrollControlDirective } from './directives/scroll-controll.directive';
import { CollectionService }      from './services/collection.service';
import { DataService }            from './services/data.service';

@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ ScreenSizeDirective, ScrollControlDirective ],
  exports:      [ ScreenSizeDirective, ScrollControlDirective ],
  providers:    [
    UserService,
    NetworkService,
    EventsService,
    ScreenSizeService,
    LanguageService,
    WishListService,
    CartService,
    AuthenticationService,
    CollectionService,
    DataService
  ]
})
export class CoreModule {

  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(config: AppConfig): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: AppConfig, useValue: config }
      ]
    };
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/core.module.ts